import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { NotFound } from 'common/components';

import { DASHBOARD_ROUTES } from '../../routes';
//import ProfileWidget from './components/ProfileWidget';
import AddAdmin from './components/AddAdmin';
import AddUserContainer from './containers/AddUserContainer';
import ChangePasswordContainer from './containers/ChangePassword';

const ProfileContainer = () => {
  // const { userId = '' } = useAuth();

  // const userPro = useFetchUser(userId);

  // let user: User = {
  //   id: '',
  //   isConfirmed: false,
  //   email: '',
  //   Username: '',
  // };
  // userPro.then((result) => {
  //   user = result.user;
  // });

  // if (!user) {
  //   return <LoadingScreen />;
  // }

  return (
    <Routes>
      <Route
        element={
          <>
            {/* <ProfileWidget> */}
            <Outlet />
            {/* </ProfileWidget> */}
          </>
        }
      >
        <Route
          index
          element={<Navigate replace to={DASHBOARD_ROUTES.profileChangePassword.to} />}
        />
        <Route
          path={DASHBOARD_ROUTES.profileChangePassword.path}
          element={<ChangePasswordContainer />}
        />
        <Route path={DASHBOARD_ROUTES.addUser.path} element={<AddUserContainer />} />
        <Route path={DASHBOARD_ROUTES.addAdmin.path} element={<AddAdmin />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default ProfileContainer;
